<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="row">
          <div class="col">
            <div class="card-header">
              <h4 class="card-title">CMS SEO</h4>
            </div>
            <div class="card-body">
              Custom component
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    components: {
    },
    data () {
      return {
      }
    }
  }
</script>
<style>

</style>
